<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <Breadcrumbs main="Abatement Map" title="default" />
  
    <div class="container-fluid p-0">
      <div class="row widget-grid">
        <el-row class="m-0 width-100-p my-30">
          <!-- <el-col v-if="missingFields.length > 0" :span="$vuetify.display.width >= 1200 ? 24 : $vuetify.display.width >= 500 ? 24 : 24">
                <label class="warning-message radio-label font-12 ml-3" :style="{'max-width': $vuetify.display.width <= 1485 ? 'auto' : $vuetify.display.width <= 1578 ? '400px' : $vuetify.display.width <= 1651 ? '450px' : '500px'}">
                  {{ `* Please input: ${missingFields.join(", ")}  from custom filter to view the map.` }}
                </label>
          </el-col> -->
          <!-- <el-col class="d-flex align-item-center px-2" :span="24">
            <div class="row m-0 width-100-p">
              <div
                class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
              >
                  <div class="row m-0" :span="24">
                    <el-row gutter="20" class="row m-0">

                    </el-row>


                  </div>
              </div>
            </div>
          </el-col> -->

          <el-col class="d-flex align-item-center px-2" :span="24">
              <div class="m-0 width-100-p">
                <div
                  class=" m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
                >
                  <el-row>
                      <!-- Title and Filter -->
                      <el-col
                        :span="$vuetify.display.width >= 1339 ? 8 : $vuetify.display.width >= 1000 ? 12 : $vuetify.display.width >= 768 ? 10 : 24"
                        class="width-100-p p-0"
                      >
                        <el-col :span="24">
                          <h5 class="moderat-white-bold m-l-10">Abatement within Radius</h5>
                        </el-col>
                        <FilterS6 
                          :periodNameProp="`Current MP`"
                          :stateProp="stateList"
                          @filterHandle="filterHandle"
                          />
                      </el-col>
                      
                      <!-- Map -->
                      <el-col 
                        class="pr-20 pl-10"
                        :span="$vuetify.display.width >= 1339 ? 16 : $vuetify.display.width >= 1000 ? 11 : $vuetify.display.width >= 768 ? 13 : 24">
                        <showMap
                          :mapDataProp="mapData" />
                      </el-col>

                      <!-- Total Card -->
                      <el-col
                            :span="24"
                            class="width-100-p p-2"
                          >
                            <showTotalCard :cardProp="total_list" />
                      </el-col>
                  </el-row>
                </div>
              </div>
            
          </el-col>
        </el-row>




        <el-row class="m-0 width-100-p mb-30">
          <el-col class="d-flex align-item-center px-2" :span="24">
            <div class="row m-0 width-100-p">
              <div
                class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
              >
                <el-col :span="24">
                  <div class="row m-0">

                    <el-col :span="24">
                    
                      <DataTable
                          :dataProp="dataList"
                          :loadingProp="loading"
                          :totalRowProp="total_items"
                          @tableAction="handleTableAction"
                        />
                    </el-col>
                  </div>
                </el-col>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>


    </div>
  </template>
  
  <script>

  import UserService from "../../../services/user.service";
  import DataTable from "./showTables.vue";
  // import Filter from "../common/filter.vue";
  import FilterS6 from "../common/filter-s6.vue";
  import showMap from "./showMap.vue";
  import showTotalCard from "./showTotalCard.vue";
  // import { ElMessageBox } from "element-plus";

  export default {
    props: {},
    components: {
      DataTable,
      // Filter,
      FilterS6,
      showMap,
      showTotalCard,
    },
    watch: {},
    computed: {
      stateList() {
        return this.states;
      },
    },
    data() {
      return {
        mapTheme: "light",
        map: {
            url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
            attribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            zoom: 10,
            center: [-37.8136, 144.9631],
            markerLatLng: [],
        },    // Leaflet map instance
        circle: null,   // Circle layer

        mapData: {
          center_lat: null,
          center_lng: null,
          radius: null,
          unit: null,
          site_list: [],
        },

        total_list: [],

        current_page: 1,
        perPageCount: 50,
        total_items: 100,
        search_by: "site_name",
        search: "",
        dataList: [],
        loading: true,
        states: [],
        stateFilter: null,
        filter: {
          state: null,
          customer_id: null,
          start_date: null,
          end_date: null,
        },

        leafletMap: null,

        missingFields: [],



      };
    },
    mounted() {


    },
    methods: {

      checkMissingFields(filter) {
        const missingFields = [];

        Object.keys(filter).forEach((key) => {
          // console.log("key", key);
          // console.log("filter[key]", filter[key]);
          if (key === "customer_id") {
            return; // Skip the key "customer_id"
          } else if (key === "lat" || key === "lng" || key === "radius") {
            if (filter[key] !== null && filter[key] !== undefined && filter[key] !== "") {
              return;
            } else {
              missingFields.push(key);
            }
          } else if (filter[key] == null || filter[key] === "") {
            missingFields.push(key);
          }
        });

        if (missingFields.length > 0) {
          console.log("Missing fields:", missingFields);
          this.missingFields = missingFields;
          
          this.loading = false;
          return true;
        }
        // console.log("All required fields are present:", filter);
        this.missingFields = [];
        return false;
      },
    
      fetchData(filter) {
        let request = filter;
        this.loading = true;
       

        let hasMissingField = false;
        hasMissingField = this.checkMissingFields(request)
        if (hasMissingField === true) {
          // console.log("Missing fields in filter:", request);
          return;
        } else {
          UserService.abtWithinRadius(request)
          .then(
            (response) => {
                
                this.dataList = response.data;
                
                this.site_list = response.data.site_list;
                // console.log("site_list", this.site_list);
                
            },
            (error) => {
              this.loading = false;
              console.log(error);
              if (error.response.status == 401) {
                this.$router.push({
                  path: "/",
                });
              }
            }
          ).then(
            () => {
                this.mapData.center_lat = request.lat;
                this.mapData.center_lng = request.lng;
                this.mapData.radius = request.radius;
                this.mapData.unit = request.unit;
                this.mapData.site_list = this.site_list;
                // console.log("mapData", this.mapData);

                this.total_list = this.dataList.total_list;

                
            }
          )
          .catch((error) => {
            this.loading = false;
            console.log(error);
          })
          .finally(() => (this.loading = false));
        }
      },


  
      handleReload() {
        this.fetchData();
      },
      handleTableAction(event) {
        if (event.kind == "changePage") {
          this.current_page = event.index;
          this.handleReload();
        } else if (event.kind == "perPageChange") {
          this.current_page = 1;
          this.perPageCount = event.index;
          this.handleReload();
        }
      },
      filterHandle(event) {
        // console.log("filterHandle", event);

        this.filter = {
          start_date : event.startDate || event.start_date || null,
          end_date : event.endDate || event.end_date || null,
          lat : event.lat || 0,
          lng : event.lng || 0,
          radius : event.radius || 0,
          unit : event.unit || null,
          customer_id : event.customer_id || null,
        }
        
       let hasMissingField = false;
        hasMissingField = this.checkMissingFields(this.filter)
        if (hasMissingField === true) {
          console.log("Missing fields in filter");
          return;
        } else {
          // console.log("request", this.filter);
          // this.stateFilter = event.state;
          this.fetchData(this.filter);
        }
      },
    },
  };
  </script>
  
  <style>
  .warning-message {
    color: #ffaa05;
    font-size: 12px;
    padding: 2px;
    border-radius: 5px;
    font-family: Moderat;
  }
  </style>
  